import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-user-points',
  templateUrl: './user-points.component.html',
  styleUrls: ['./user-points.component.scss']
})
export class UserPointsComponent implements OnInit {

  userId: any;
  points: any;
  isLoggedIn = false;

  constructor(
    private coreService: CoreService,
    private authService: AuthService,
    private toast: ToastrService,
    private translate: TranslateService
  ) { 
    this.isLoggedIn = this.authService.IsLoggedIn();
  }

  ngOnInit() {
    if(this.isLoggedIn) {
      this.getUserPoints();
    }

    this.authService.loginEmitter.subscribe((response: boolean) => {
      this.isLoggedIn = response;
      if(this.isLoggedIn) {
        this.getUserPoints();
      }
    });

    this.coreService.pointsEmitter.subscribe((response: any) => {
      this.getUserPoints();
    });
  }

  getUserPoints() {
    if (this.isLoggedIn) {
      this.userId = this.authService.getUserId();
      this.coreService.getPoints(this.userId).then((response: any) => {
        this.points = response.result.points;
      }).catch((errorResponse: any) => {
        const errorMessage = this.translate.instant(errorResponse.error.messageKey);
        this.toast.error(errorMessage, '');
      })

    }
  }

}
